import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Objects } from '../../../util/objects';

@Component({
  selector: 'ngx-more-column',
  template: `<button nbButton size="tiny" outline shape="round" (click)="onClick()">{{ buttonLabel }}</button>`,
  encapsulation: ViewEncapsulation.None,
})
export class MoreColumnComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;
  public buttonLabel: string = "";

  constructor(private router: Router) {}

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.buttonLabel = Objects.safeGetValue(this.params, 'buttonLabel', "");
  }

  ngOnInit() {
  }

  onClick() {
    this.params.context.showMore(this.params.data);
  }
  
}
